import { render, staticRenderFns } from "./transmission-oil-recommend.vue?vue&type=template&id=3614919c&scoped=true&"
import script from "./transmission-oil-recommend.vue?vue&type=script&lang=js&"
export * from "./transmission-oil-recommend.vue?vue&type=script&lang=js&"
import style0 from "./transmission-oil-recommend.vue?vue&type=style&index=0&id=3614919c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3614919c",
  null
  
)

export default component.exports